import styled from 'styled-components';

import { BodySmallRegular, BodyStandardSemiBold, Colour } from '@xemplo/style-constants';

export const Form = styled.div`
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

export const Fieldset = styled.fieldset`
  border: none;
  padding: 0;
  margin: 0;
  gap: 12px;
  width: 100%;
  display: grid;
  grid-template-columns: 1fr 1fr;
`;

export const Legend = styled.div`
  ${BodyStandardSemiBold};
  color: ${Colour.Gray[800]};
  margin-bottom: 24px;
  display: flex;
  gap: 24px;
  flex-direction: column;
  grid-column: 1/-1;
`;

export const Subtitle = styled.span`
  ${BodySmallRegular};
  color: ${Colour.Gray[400]};
`;

export const RadioGroupWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;
